import React from 'react';
import styles from './RolesAndPermissions.module.scss';
import { v4 as uuid } from 'uuid';
import { PropertyType } from '../../../common';
import { Role } from '../../components';

export const getRows = (roles: PropertyType[]): PropertyType[] => {
	return roles.map((r: PropertyType) => [
		<span key={uuid()}>
			<Role name={r.name} color={r.color} />
		</span>,
		<span key={uuid()}>{r.members}</span>,
		<section key={uuid()} className={styles.RoleActions}>
			{/*<RoleActions className={styles.Actions} name={r.name} />*/}
		</section>,
	]);
};
